<template>
  <div>
    <el-row :data="headData">
      <el-col :span="6">
        <p>公司：{{ companyName }}</p>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top:0;margin-top:0">
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row v-loading="loading" style="width: 100%">
      <el-col>
        <el-tabs type="card" @tab-click="handleFirstCatalogClick">
          <el-tab-pane v-for="item in firstCatalogData" :label="item.NAME" :key="item.INNER_CODE" :data="item"
            :code='item.INNER_CODE'></el-tab-pane>
        </el-tabs>
        <el-tabs @tab-click="handleSecondCatalogClick" v-model="activeName" :tab-position="'left'" class="second">
          <el-tab-pane v-for="item in secondCatalogData" :name="item.INNER_CODE.toString()" ref="secondCat"
            :label="item.NAME" :key="item.INNER_CODE" :code='item.INNER_CODE'>
          </el-tab-pane>
          <!-- 产品列表 -->
          <el-col class="product_main" :xl="23" :md="21" :lg="22">
            <div v-loading="loading1" ref="products_view">
              <div v-for="item in productCatalogData" :key="item.INNER_CODE">
                <el-col :xl="4" :lg="6" :md="8" :sm="8" :xs="8" style="padding: 10px">
                  <div class="card">
                    <div class="text">
                      <p style="font-weight: bold" class="productName">{{ item.NAME }}</p>
                      <div>

                        <span>单位：&nbsp;&nbsp;&nbsp;&nbsp;{{ item.TYPE_UNIT }}</span>
                        <p> <span>当前价格：&nbsp;&nbsp;&nbsp;&nbsp;{{ item.CURRENT_PRICE }}</span></p>
                        <p><span style="width: 40%">报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</span>
                          <el-input type="text" clearable v-model="item.SUBMIT_PRICE"
                            @change="(e) => { setValue(e, item) }" style="width: 45%"></el-input>
                        </p>
                        <p v-if="customerType == 1">
                          <span style="width: 40%">税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;率：</span>
                          <el-input type="text" clearable v-model="item.SUBMIT_TAX_RATE" style="width: 45%"
                            @change="setValue"></el-input>
                        </p>
                      </div>
                    </div>
                  </div>
                </el-col>
              </div>
            </div>
          </el-col>
        </el-tabs>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button style="float:right;margin-top: 20px" @click="handleSubmit">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  getTotal, getProduct, priceSubmit, priceSearch,
} from 'api/givePrice';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      loading: true,
      loading1: false,
      // loading2:false,
      supplierName: this.$route.params.name,
      firstCatalogCode: 0,
      secondCatalogCode: 0,
      firstCatalogData: [],
      secondCatalogData: [],
      productCatalogData: {},
      catalogData: [],
      companyName: sessionStorage.getItem('customerName'),
      code: '',
      activeName: '',
      headData: {},
      // 存放全部的产品信息
      ALL_PRODUCTS: [],
      // 产品是否加载完毕
      isLoadComplate: false,
      // 下滑加载的次数
      loadCount: 1,
      // 当前滚动距离顶部的距离
      currentTop: 0,
      searchForm: {
        name: '',
      },
      productArray: [],
      pageSize: 10,
      customerType: sessionStorage.getItem('customerType'),
    };
  },
  methods: {
    defaultQuery() {
      const data = {
        CUSTOMER_ID: sessionStorage.getItem('customerId'),
        CUSTOMER_TYPE: this.customerType,
      };
      getTotal(data).then((result) => {
        if (result[0]) {
          this.firstCatalogData = result[0].CATALOGS;
          this.secondCatalogData = this.firstCatalogData[0].SECOND_CATALOGS;
          this.activeName = this.secondCatalogData[0].INNER_CODE.toString();
          this.productCatalogData = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_PRICE: item.SUBMIT_PRICE ? item.SUBMIT_PRICE : item.CURRENT_PRICE, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.secondCatalogCode = this.secondCatalogData[0].INNER_CODE;
          this.loadProducts();
        } else { this.$message.show({ text: '暂无数据', type: 'success' }); }
        this.loading = false;
        this.loading1 = false;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
        this.loading = false;
        this.loading1 = false;
      });
    },
    handleFirstCatalogClick(content) {
      this.loading1 = true;
      this.firstCatalogCode = content.$attrs.code;
      this.catalogData = content.$attrs.data;
      this.secondCatalogData = this.catalogData.SECOND_CATALOGS;
      this.secondCatalogCode = this.secondCatalogData[0].INNER_CODE;
      this.activeName = this.secondCatalogCode.toString();
      this.handleProduct(this.secondCatalogCode);
    },
    handleProduct(content) {
      this.loading1 = true;
      this.productCatalogData = [];
      const data = {
        CUSTOMER_ID: sessionStorage.getItem('customerId'),
        CUSTOMER_TYPE: this.customerType,
        SECOND_CATALOG_CODE: content,
      };
      getProduct(data).then((result) => {
        if (result[0]) {
          this.ALL_PRODUCTS = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_PRICE: item.SUBMIT_PRICE ? item.SUBMIT_PRICE : item.CURRENT_PRICE, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.loadProducts();
          this.loading1 = false;
        } else {
          this.productCatalogData = [];
          this.loading1 = false;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      })
        .catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
          this.loading = false;
          this.loading1 = false;
        });
    },
    handleSecondCatalogClick(content) {
      this.loading1 = true;
      this.secondCatalogCode = content.$attrs.code;
      const data = {
        CUSTOMER_ID: sessionStorage.getItem('customerId'),
        CUSTOMER_TYPE: this.customerType,
        SECOND_CATALOG_CODE: this.secondCatalogCode,
      };
      getProduct(data).then((result) => {
        if (result.length !== 0) {
          this.productCatalogData = result[0].PRODUCTS.map((item) => ({ ...item, SUBMIT_PRICE: item.SUBMIT_PRICE ? item.SUBMIT_PRICE : item.CURRENT_PRICE, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          this.loading1 = false;
        } else {
          this.productCatalogData = [];
          this.loading1 = false;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
        this.loading = false;
        this.loading1 = false;
      });
    },
    handleSubmit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            CUSTOMER_ID: sessionStorage.getItem('customerId'),
            CUSTOMER_TYPE: this.customerType,
            SECOND_CATALOG_CODE: this.secondCatalogCode,
            PRICE_ARRAY: this.productArray,
          };
          priceSubmit(data).then((result) => {
            this.$message.show({ text: '商品报价成功', type: 'success' });
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    loadProducts(pageIndex = 0, pageSize = this.pageSize) {
      const INDEX = pageIndex * pageSize;
      // 注意slice()函数的用法,前闭后开[)
      const END = INDEX + pageSize;
      if (this.productCatalogData.length < this.ALL_PRODUCTS.length && INDEX < this.ALL_PRODUCTS.length) {
        if (END > this.ALL_PRODUCTS.length) {
          this.productCatalogData.push(...this.ALL_PRODUCTS.slice(INDEX));
        } else {
          this.productCatalogData.push(...this.ALL_PRODUCTS.slice(INDEX, END));
        }
      } else {
        // 已经加载完毕
        this.isLoadComplate = true;
      }
    },
    setViewHeight() {
      this.$refs.products_view.style.height = `${window.innerHeight - 365}px`;
      this.$refs.products_view.style.overflowY = 'scroll';
    },
    handleSearch() {
      if (this.searchForm.name) {
        const data = {
          CUSTOMER_ID: sessionStorage.getItem('customerId'),
          CUSTOMER_TYPE: this.customerType,
          PRODUCT_NAME: this.searchForm.name,
        };
        priceSearch(data)
          .then((result) => {
            this.productCatalogData = result.map((item) => ({ ...item, SUBMIT_PRICE: item.SUBMIT_PRICE ? item.SUBMIT_PRICE : item.CURRENT_PRICE, SUBMIT_TAX_RATE: item.TAX_RATE ? item.TAX_RATE : 0 }));
          })
          .catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
          });
      } else {
        this.productCatalogData = [];
        this.defaultQuery();
      }
    },
    setValue(e, item) {
      if (!validation.价格正数验证(item.SUBMIT_PRICE)) {
        this.$message.show({ text: '请输入正数单价', type: 'warning' });
        return false;
      }
      this.productArray = this.productCatalogData.filter((item) => (item.CURRENT_PRICE !== item.SUBMIT_PRICE || item.TAX_RATE !== item.SUBMIT_TAX_RATE) && item.SUBMIT_PRICE !== '').map((item) => ({
        PRODUCT_CODE: item.INNER_CODE,
        SUBMIT_PRICE: parseFloat(item.SUBMIT_PRICE),
        TAX_RATE: Number(item.SUBMIT_TAX_RATE),
        CATALOG_ID: item.CATALOG_ID,
      }));
    },
  },
  mounted() {
    // 监听产品框的滚动事件
    const PRODUCTS_VIEW = this.$refs.products_view;
    PRODUCTS_VIEW.addEventListener('scroll', () => {
      const SCROLL_TOP = PRODUCTS_VIEW.scrollTop;
      if (SCROLL_TOP > 0 && SCROLL_TOP % 5 === 0 && SCROLL_TOP > this.currentTop && !this.isLoadComplate) {
        this.loadProducts(this.loadCount);
        this.loadCount++;
        this.currentTop = SCROLL_TOP;
      }
    });
    this.setViewHeight();
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.defaultQuery();
  },
};
</script>
<style>
.text {
  font-size: 14px;
  margin: 10px;
}

.card {
  width: 100%;
  /* height: 150px; */
  height: fit-content;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.second .el-tab-pane {
  height: 600px;
  overflow-y: auto;
}

.productName {
  height: 35px;
  overflow: hidden;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.product_main {
  position: absolute;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/SubmitPrice.vue